import { DatePipe } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import moment from 'moment';
import { ButtonColor } from 'src/app/model';
import { ServicecallService } from 'src/app/services';

@Component({
  selector: 'app-telemetry-download-popover',
  templateUrl: './telemetry-download-popover.component.html',
  styleUrl: './telemetry-download-popover.component.css'
})
export class TelemetryDownloadPopoverComponent {

  buttonColor = ButtonColor.SECONDARY;
  teleHistoryConfig: any;
  alertBackwards: boolean = false;
  alertForward: boolean = false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<any>,
  private _datePipe: DatePipe,  private _service: ServicecallService) {
    this.teleHistoryConfig = this._service.getAlertAnalyzeTelemetryConfig(this.data?.fuelType, 'export') ?? [];  }

  onFormActionClick(action) {
    if(action === 'yes'){
      this.activeEntityExport();
      this.dialogRef?.close(true);
    } else {
      this.dialogRef?.close();
    }
  }

  downloadOptionSelection(type: string) {
    type === 'alertBackwards' ? this.alertBackwards = !this.alertBackwards : this.alertForward = !this.alertForward;
    if(type === 'alertBackwards'){
      this.alertForward = false;
    }else {
      this.alertBackwards = false;
    }
  }

  activeEntityExport() {
    let startDate;
    let endDate;
    if(this.alertForward) {
      startDate = new Date(this.data?.details?.originalTime);
      endDate = this.getDate5DaysForward(this.data?.details?.originalTime);
    }
    if (this.alertBackwards) {
      startDate = this.getDate5DaysBehind(this.data?.details?.originalTime);
      endDate = new Date(this.data?.details?.originalTime);
    }
    const reqParam = {
      from: this._datePipe.transform(startDate, 'yyyy-MM-ddTHH:mm:ssZZ'),
      to: this._datePipe.transform(endDate, 'yyyy-MM-ddTHH:mm:ssZZ'),
      entityId: this.data?.details?.entityId,
      exportFormat: 'csv',
      timezone: sessionStorage.getItem('selectedTimeZone') ? sessionStorage.getItem('selectedTimeZone') : moment.tz.guess(),
      exportFilename: 'Telematics History',
      fields: this.teleHistoryConfig?.[0]?.export?.telematicsHistory ?? [],
      ...(this.alertForward && {
        "sortBy": {
          "sourceTimestamp": {
              "order": "asc"
          }
      }
      })
    }
    this._service.commonExport('csv', reqParam, 'activeEntityExport', 'Export_Telematics_History_')
  }

  getDate5DaysBehind(providedDate: string) {
    const date = new Date(providedDate);
    date.setDate(date.getDate() - 5); 
    return date; 
  }

  getDate5DaysForward(providedDate: string) {
    const date = new Date(providedDate);
    date.setDate(date.getDate() + 5); 
    return date; 
  }


}
